import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';
import { RequestView } from 'src/app/model/requestview';
import { AcceptWebOrder } from 'src/app/model/WebOrderSetup/acceptweborder';
import { AcceptWebOrderDto } from 'src/app/model/WebOrderSetup/acceptweborderdto';
import { AcceptWebOrderPositionDto } from 'src/app/model/WebOrderSetup/acceptweborderpositiondto';
import { AssignShippingDto } from 'src/app/model/WebOrderSetup/assign-shipping-dto';
import { LocationDetailsForStore } from 'src/app/model/WebOrderSetup/locationdetailsforstore';
import { ServiceManStatusDto } from 'src/app/model/WebOrderSetup/service-man-status-dto';
import { ServiceMan } from 'src/app/model/WebOrderSetup/serviceman';
import { HandleError, HttpErrorHandlerService } from '../http-error-handler.service';
import { RiderDetailsDto } from 'src/app/model/WebOrderSetup/rider-details-dto';
import { DispatchStorePickupOrder } from 'src/app/model/OrderManagement/WebOrder/dispatch-store-pickup-order';
import { catchError } from 'rxjs/operators';
import { WebOrderAllowProductDto } from 'src/app/model/web-order-allow-product-dto';

@Injectable({
  providedIn: 'root'
})
export class WebOrderService {

  private handleError: HandleError;
  constructor(
    private http: HttpClient,
    private apiURL: APIFactoryEndPoints,
    httpErrorHandler: HttpErrorHandlerService,
    httpErrorHandle: HttpErrorHandlerService,
    private apiFactory: APIFactoryEndPoints
  ) {
    this.handleError = httpErrorHandle.createHandleError('WebOrderService');
  }

  onViewSetUp(url: string, req: RequestView) {

    return this.http.post(
      url,
      req,
      { responseType: 'json' }

    );
  }

  getServiceManListByLocId(locationCode: number[]): Observable<any> {
    return this.http.get<ServiceMan[]>(this.apiFactory.getServiceManByLocation + '/' + locationCode)
  }

  updateServiceman(refNo: number, orderNo: string): Observable<any> {
    return this.http.patch(this.apiFactory.updateServiceman + '/' + refNo + '/' + orderNo, { responseType: 'json' })
  }

  onViewSetUpForOrders(url: string, req: RequestView) {

    return this.http.post(
      url,
      req,
      { responseType: 'json' }

    );
  }

  insertAssetWebOrder(url: string, req: AcceptWebOrderDto) {

    return this.http.post<any>(
      url,
      req,
      { responseType: 'json' }

    );
  }

  onViewLiveWebOrderLocationSetUp(url: string, req: RequestView) {

    return this.http.post(
      url,
      req,
      { responseType: 'json' }

    );
  }

  getAcceptWebOrderByLocationDetails(locationCode: number): Observable<any> {
    return this.http.get<AcceptWebOrder>(this.apiFactory.getAcceptWebOrderByLocationDetails + '/' + locationCode)
  }

  getLocationByLocationCode(url: string, locationCode: number) {
    return this.http.get<LocationDetailsForStore>(url + "/" + locationCode);
  }

  getLocationByAllLocationCode(url: string, locationCode: number[]) {
    return this.http.get<LocationDetailsForStore>(url + "/" + locationCode);
  }

  getAcceptWebOrderAllPositionDetails(url: string, locationCode: number[]) {
    return this.http.get<AcceptWebOrderPositionDto[]>(url + "/" + locationCode);
  }

  getAcceptWebOrderPositionDetails(url: string, locationCode: number) {
    return this.http.get<AcceptWebOrderPositionDto[]>(url + "/" + locationCode);
  }

  getServiceManByDate(url: string, date: string, locId: number) {
    return this.http.get<ServiceManStatusDto[]>(url + "/" + date + "/" + locId)
  }

  saveShipping(url: string, obj: AssignShippingDto) {
    return this.http.post(
      url, obj, { responseType: 'json' }
    )
  }

  getAssignedDetailsById(url: string, id: string) {
    return this.http.get<any>(url + "/" + id)
  }

  getWebUserInfoData(url: string, obj: any): Observable<any> {
    return this.http.post<any>(
      url, obj
    );
  }

  getWebUserInitailData(url: string) {
    return this.http.get<any>(
      url
    );
  }

  updateStatus(url: string, orderNo: string, status: string, type: string): Observable<any> {
    return this.http.get<any>(url + '/' + orderNo + '/' + status + '/' + type)
  }


  onViewRiderSetUp(url: string, req: any) {
    return this.http.post(url, req)
  }

  approveRider(url: string, obj: any): Observable<any> {
    return this.http.post<any>(
      url, obj
    );
  }

  rejectRider(url: string, obj: any): Observable<any> {
    return this.http.post<any>(
      url, obj
    );
  }

  saveDispatchToStore(url: string, obj: DispatchStorePickupOrder) {
    return this.http.post<any>(url, obj);
  }

  saveDeliveryAtStore(url: string, storePickupId: number) {
    return this.http.patch<any>(url + "/" + storePickupId, null);
  }

  savePickupAtStore(url: string, storePickupId: number, otp: string) {
    return this.http.patch<any>(url + "/" + storePickupId, otp);
  }

  orderReturnToParent(url: string, storePickupId: number, reason: string) {
    return this.http.patch<any>(url + "/" + storePickupId, reason);
  }

  orderReturnReceiveAtParent(url: string, storePickupId: number) {
    return this.http.patch<any>(url + "/" + storePickupId, null);
  }

  actionToCostomWebOrder(url: string, obj: any): Observable<any> {
    return this.http.post<any>(
      url, obj
    );
  }

  getTimeSlotList(url: string) {
    return this.http.get<any[]>(url);
  }

  getImage(url: string, img: String): any {

    return this.http.get<any>(url + img, { responseType: 'arraybuffer' as 'json' })
      .pipe(
        catchError(this.handleError('getImage', "SORRY"))
      );
  }

  statusUpdate(url: string, refNo: any, type: string, reason: string, status: string) {
    return this.http.get<any>(url + '/' + refNo + '/' + type + '/' + reason + '/' + status)
  }

  updateWeborder(url: string, orderNo: string, deliveryDate: string, deliverytime: string) {
    return this.http.get<any>(url + "/" + orderNo + "/" + deliveryDate + "/" + deliverytime)
  }

  getWebOrderBillingSetUpByLocationCode(locationCode: number): Observable<any> {
    return this.http.get<any>(this.apiFactory.getWeborderBillingsetupByLocid + '/' + locationCode)
  }

  getWebOrderAllowProductList(url: string, currentUrl: string) {
    return this.http.get<WebOrderAllowProductDto[]>(url + "/" + currentUrl);
  }

  getWebOrderAllowProductQtySetup(url: string, currentUrl: string, locId: number) {
    return this.http.get<WebOrderAllowProductDto[]>(url + "/" + currentUrl + "/" + locId);
  }

  placeOrder(url: string, webOrderDetails: DispatchStorePickupOrder) {
    return this.http.post<any>(url , webOrderDetails );
  }

  // newly added for web order
  savePickupAtStoreForWebOrder(url: string, orderNo: string, otp: string) {
    return this.http.patch<any>(url + "/" + orderNo, otp);
  }

  insertCCAvenueResponse(url: string, orderId: string, currentUrl: string) {
    return this.http.get<any>(url + "/" + orderId + "/" + currentUrl);
  }
}